import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import icons from 'assets/icons'
import Spinner from 'components/loader/Spinner'
import { useState, useEffect } from 'react'
import Button from 'components/formElements/Button'
import PropTypes from 'prop-types'
import { useRequest } from 'hooks/useRequest'
import { Dialog } from 'primereact/dialog'
import { Calendar } from 'primereact/calendar'
import moment from 'moment'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { useDispatch, useSelector } from 'react-redux'
import { closeApprovalModal } from 'redux/features/general/generalSlice'
import ApprovalContent from 'components/modalContent/ApprovalContent'
import useToast from 'hooks/useToast'
import { Link } from 'react-router-dom'
import { getPermission } from 'utils/Auth'
import useWindowSize from 'hooks/useWindowSize'

const WeeklyPlan = () => {
    const [request] = useRequest()
    const [getDevelopersLoading] = useRequest()
    const dispatch = useDispatch()
    const { general } = useSelector((state) => state)
    const { approvalModal } = general
    const [createDev, setCreateDev] = useState()
    const { showToast } = useToast()
    const [weeklyData, setWeeklyData] = useState([])
    const { width } = useWindowSize()
    const [deletePlan, setDeletePlan] = useState(false)
    const [deleteData, setDeleteData] = useState()
    const [deleteDataFinish, setDeleteDataFinish] = useState(false)





    const handleCloseModal = () => {
        setCreateDev()
    }

    useEffect(() => {
        request('/WeeklyPlan/GetWeeklyPlanAllWeekNumber', { method: 'GET' }).then((res) => {
            if (res.data) {
                setWeeklyData(res.data)
            }
        })
    }, [])

    const handleSubmitApproval = () => {
        request(approvalModal.deleteEndpoint, {
            method: 'DELETE',
            data: { id: approvalModal.deleteData.id },
        }).then(async (res) => {
            if (!res.data.metadata) {
                handleCloseApprovalModal()

            }
        })
    }
    const handleCloseApprovalModal = async () => {
        dispatch(closeApprovalModal())
    }
    const handleChange = (e, name) => {
        if (name) {
            const today = moment(e).format('YYYY-MM-DD');
            request('/WeeklyPlan/CreateWeeklyPlan', {
                method: 'POST',
                params: {
                    date: today
                }
            }).then((res) => {
                showToast('Haftalık Plan Şablonu Oluşturuldu', 'success')
                if (res.data) {
                    request('/WeeklyPlan/GetWeeklyPlanAllWeekNumber', { method: 'GET' }).then((res) => {
                        if (res.data) {
                            setWeeklyData(res.data)
                            handleCloseModal()

                        }
                    })

                }
            })
        }
    }

    const createDevFunc = () => {
        setCreateDev(true)
    }

    const handleDeleteRow = (deleteData) => {
        setDeletePlan(true)
        setDeleteData(deleteData)

    }

    useEffect(() => {
        if (deleteDataFinish) {
            request('/WeeklyPlan/DeleteWeeklyPlan', {
                method: 'POST',
                params: {
                    weekNumber: deleteData.week,
                    year: deleteData.year
                }
            }).then(() => {
                request('/WeeklyPlan/GetWeeklyPlanAllWeekNumber', { method: 'GET' }).then((res) => {
                    if (res.data) {
                        setWeeklyData(res.data)

                        showToast('Haftalık Plan Silindi.', 'success')
                        setDeletePlan(false)
                        setDeleteDataFinish(false)
                    }
                })
            })
        }
    }, [deleteDataFinish])

    return (
        <AnimatedSpan className='page-container d-flex flex-column'>
            {!getDevelopersLoading ? (
                <div className='d-flex w-100 justify-content-center'>
                    <Spinner size={3} />
                </div>

            ) : (
                <DataTable
                    value={weeklyData}
                    header={() => (
                        <div className='d-flex justify-content-between gap-3'>

                            <div></div>
                            <div className='filters-right'>
                                {getPermission('Developer.create') && (
                                    <Button
                                        handleClick={() => createDevFunc()}
                                        className='btn-success'
                                        title={width <= 936 ? '' : 'Haftalık Plan Ekle'}
                                        icon={<icons.plus />}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                >
                    <Column field="displayName" header="Hafta Bilgisi" />
                    <Column field="week" header="Hafta" />
                    <Column field="year" header="YIL" />
                    <Column
                        header='Aksiyonlar'
                        body={(rowData) => {
                            return (
                                <span className={` cellSetTransparent text-sm d-flex justify-content-between`} >
                                    {
                                        <>

                                            <div className='d-flex gap-1  '>
                                                <Link target='_blank' className='new-page-link-icon' to={`/weekly-plan/${rowData.week}-${rowData.year}`}>
                                                    < Button
                                                        icon={<icons.dashboard className='mr-1' size={20} />}
                                                        className='btn-success-outline'
                                                        title='Plan Bilgisi Görüntüle'
                                                    />
                                                </Link>
                                            </div>
                                            <icons.delete
                                                onClick={() => handleDeleteRow(rowData)}
                                                className='devs-list-card-settings-icon ml-2 mt-2 cursor-pointer'
                                                size={24}
                                                color='black'
                                            />{' '}
                                        </>
                                    }
                                </span>
                            )
                        }}
                    />

                </DataTable>
            )
            }
            {
                createDev && (
                    <Dialog visible={createDev} onHide={handleCloseModal} draggable={false} header='Yeni Haftalık Plan' className='w-70'>
                        <div className='form d-flex flex-column gap-3 mt-2 '>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-control'>
                                        <label className=''>Haftalık Plan Tarihi</label>

                                        <Calendar
                                            dateFormat='dd/mm/yy'
                                            placeholder='Haftalık Plan Tarihi giriniz'
                                            name='startDate'
                                            onChange={(e) => {
                                                handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
                                            }}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Dialog>
                )
            }
            {
                deletePlan && (
                    <Dialog visible={deletePlan} onHide={handleCloseModal} draggable={false} header='' className='w-70'>
                        <div className='form d-flex flex-column gap-3 mt-2 '>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-control'>
                                        <label className=''>Haftalık Planı Silmek istediğinize Emin misin?</label>

                                        <div className='d-flex  justify-content-around mt-3'>
                                            <Button title="Onayla" handleClick={() => setDeleteDataFinish(true)} className="btn-success" />
                                            <Button title="Vazgeç" handleClick={() => setDeletePlan(false)} className="btn-danger" />

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Dialog>
                )
            }
            <Dialog draggable={false} visible={approvalModal.open} onHide={handleCloseApprovalModal}>
                <ApprovalContent handleClose={handleCloseApprovalModal} handleApproved={handleSubmitApproval} />
            </Dialog>
        </AnimatedSpan >
    )
}

WeeklyPlan.proptypes = {
    createDev: PropTypes.bool,
    setCreateDev: PropTypes.func,
}
export default WeeklyPlan
